import { Avatar, type AvatarProps } from '@/components/ui/Avatar';
import { MemberAvatar } from '@/features/members';

import { type LinkedMember, personLabel } from '../../schemas/attendance.schema';

export interface PersonAvatarProps {
  person: { member: LinkedMember | null; name: string | null; deviceUserId: string };
  size?: NonNullable<AvatarProps['size']>;
}

/** The member's photo once the machine user is linked to them; initials until then. */
export function PersonAvatar({ person, size = 'md' }: PersonAvatarProps) {
  const label = personLabel(person);
  if (!person.member) return <Avatar name={label} size={size} />;
  return (
    <MemberAvatar
      memberId={person.member.id}
      photoPath={person.member.photoPath}
      name={label}
      size={size}
    />
  );
}
